import React from "react";
import MenuList from "./MenuList";

const Sidebar = () => {
  return (
    // <div>
    //   This is my MenuThis is my MenuThis is my MenuThis is my MenuThis is my
    //   MenuThis is my MenuThis is my Menu
    // </div>
    <MenuList
      sx={{
        padding: 0,
        margin: 0,
        menuItem: "0.6em",
      }}
    />
  );
};
export default Sidebar;
